import { graphql } from '../../schemas/server_admin_query'

export const query_admin_search_users = graphql(`
  query query_admin_search_users($query: String) {
    users(query: $query) {
      nodes {
        id
        email
        name
        image
        locked
        roles
        active_at
        uuid
        wallet_address
        wallet_provider
        updated_at
      }
    }
  }
`)
